<template>
  <router-view></router-view>
</template>

<script>
import { SET_WINDOW_LOCATION } from "@/store/types";
import { mapGetters } from "vuex";

export default {
  name: "App",
  computed: {
    ...mapGetters(["isNotTrustyCDN", "vendorInfo"]),
  },
  mounted() {
    const titleTag = document.querySelector('title');
    if (titleTag) {
      titleTag.text = this.$t('SiteTitle');
    }
    if (!this.isNotTrustyCDN) {
      if (!this.$store.state.windowLocation?.hostname) {
        this.$store.dispatch(SET_WINDOW_LOCATION, {
          hostname: window?.location?.hostname
        });
      }
      this.neutralizeSiteTitle();
    }
  },
  watch: {
    vendorInfo: {
      immediate: true,
      handler(vendor) {
        if (vendor && !this.isNotTrustyCDN) {
          // perform cleanup of existing vendor logo link tags
          this.neutralizeSiteTitle()
          // create new link tag for the vendor logo
          if (vendor?.logo) {
            const linkTag = document.createElement('link');
            linkTag.rel = 'icon';
            linkTag.type = 'image/png';
            linkTag.href = vendor.logo;
            document.head.appendChild(linkTag);
          }
        }
      }
    }
  },
  methods: {
    neutralizeSiteTitle() {
      // find all link tags with rel="apple-touch-icon" and rel="icon" and remove them
      const linkSelector = 'link[rel="apple-touch-icon"], link[rel="icon"], meta[name="msapplication-TileImage"]'
      const linkTags = document.querySelectorAll(linkSelector);
      linkTags.forEach(link => {
        link.remove()
      });
    }
  }
};
</script> 

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
